import GoogleAnalytics from './util';

export default (...args) => GoogleAnalytics('send', 'pageview', ...args);
